<template>
  <div>
    <NBar title="设备管理"/>
    <!--设备管理-->
    <div v-if="tab === 0" id="body">
      <div style="background-color: white;">
        <nut-searchbar ref="search" v-model="query.searchName" @submit="search" style="zoom: 0.8;padding: 10px;"
                       placeText="请输入场地名称或者设备编号"/>
        <nut-row :gutter="8">
          <nut-col :span="8">
            <div @click="goStatus(-1)" class="flex-content"
                 :style="{color:query.deviceStatus === -1 ? '#1a87ff' : '#8f8f94',borderColor:query.deviceStatus === -1 ? '#1a87ff' : '#8f8f94'}">
              全部
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(0)" class="flex-content"
                 :style="{color:query.deviceStatus === 0 ? '#1a87ff' : '#8f8f94',borderColor:query.deviceStatus === 0 ? '#1a87ff' : '#8f8f94'}">
              离线
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(1)" class="flex-content"
                 :style="{color:query.deviceStatus === 1 ? '#1a87ff' : '#8f8f94',borderColor:query.deviceStatus === 1 ? '#1a87ff' : '#8f8f94'}">
              在线
            </div>
          </nut-col>
        </nut-row>
        <nut-row style="margin-top: 10px;">
          <nut-col :span="12">
            <div style="display: flex;align-items: center;">
              <div class="list list1" @click="switchMenu(1)">
                <span ref="title1">{{addressList[0].name}}</span>
                <img :src="require('../../../resource/img/device/svg/arrow-down.svg')"
                     style="width: 20px;height: 20px;">
              </div>
              <div style="height: 20px;width: 1px;background-color: #D4D4D4;"></div>
            </div>
            <nut-menu
              :is-animation="true"
              :isVisible="isVisible1"
              :list="addressList"
              type="simple"
              @close="switchMenu(1)"
              @choose="(item,index)=> chooseMenu(item,index,addressList,1)">
              <div slot="custom" class="menu-simple">
                <ul>
                  <li v-for="(item, index) in addressList" :key="index" :class="item.selected ? 'selected' : ''"
                      :style="{color: item.selected ? '#1a87ff' : '#2d2d2d'}"
                      @click="chooseMenu(item, index,addressList,1)">
                    {{ item.name }}
                    <span v-if="item.selected"><nut-icon type="tick" color="#1a87ff"></nut-icon></span>
                  </li>
                </ul>
              </div>
            </nut-menu>
          </nut-col>
          <nut-col :span="12">
            <div style="display: flex;align-items: center;">
              <div class="list list2" @click="switchMenu(2)">
                <span ref="title2">{{deviceTypeList[0].name}}</span>
                <img :src="require('../../../resource/img/device/svg/arrow-down.svg')"
                     style="width: 20px;height: 20px;">
              </div>
              <!--<div style="height: 20px;width: 1px;background-color: #D4D4D4;"></div>-->
            </div>
            <nut-menu
              :isVisible="isVisible2"
              :list="deviceTypeList"
              type="simple"
              @close="switchMenu(2)"
              @choose="(item,index)=> chooseMenu(item,index,deviceTypeList,2)">
              <div slot="custom" class="menu-simple">
                <ul>
                  <li v-for="(item, index) in deviceTypeList" :key="index" :class="item.selected ? 'selected' : ''"
                      :style="{color: item.selected ? '#1a87ff' : '#2d2d2d'}"
                      @click="chooseMenu(item, index,deviceTypeList,2)">
                    {{ item.name }}
                    <span v-if="item.selected"><nut-icon type="tick" color="#1a87ff"></nut-icon></span>
                  </li>
                </ul>
              </div>
            </nut-menu>
          </nut-col>
          <!--<nut-col :span="8">
            <div class="list list3">
              <span ref="title3" @click="switchMenu(3)">{{list3[0].text}}</span>
              <img :src="require('../../../resource/img/device/svg/arrow-down.svg')" style="width: 20px;height: 20px;">
            </div>
            <nut-menu
              :isVisible="isVisible3"
              :list="list3"
              type="simple"
              @close="switchMenu(3)"
              @choose="(item,index)=> chooseMenu(item,index,list3,3)">
            </nut-menu>
          </nut-col>-->
        </nut-row>
      </div>
      <div class="tips-div">
        <div style="display: flex;align-items: center;" @click="helpShow = true">
          <span>离线说明</span>
          <img :src="require('../../../resource/img/device/svg/help.svg')" style="width: 20px;height: 20px;">
        </div>
        <nut-dialog title="离线说明" :visible="helpShow" ok-btn-txt="我知道了" @ok-btn-click="helpShow=false" no-cancel-btn
                    @close="helpShow=false">
          <div style="text-align: left;">
            <p>如遇设备离线，可根据以下情况进行排查，如需协助，请联系平台客服</p>
            <p style="color: #2d2d2d;">可能导致设备离线、信号弱的原因：</p>
            <p>1、场地移动信号质量差（盒子使用手机GPRS信号通讯）</p>
            <p>2、场地移动基站容量不够（需联系移动运营商解决）</p>
            <p>3、天线摆放位置不佳（如在密封机台内、金属容器内等）或天线接头松动（重新拧紧即可）</p>
            <p>4、设备故障（请联系客服更换）</p>
            <p>5、无线信号的干扰源（如电磁波等）</p>
            <p style="color: #2d2d2d;">可优化方案：</p>
            <p>1、把天线从密封的机台里面拉上来，或放到设备的玻璃柜里面</p>
            <p>2、不要将天线放在四周均为金属的地方（金属会严重干扰移动信号）</p>
            <p>3、更换长天线</p>
            <p>4、更换WIFI版本设备</p>
          </div>
        </nut-dialog>
        <span>点击信号值刷新</span>
      </div>
      <div class="list-item" v-for="(item,index) in list" :key="index">
        <div class="top-item" @click="venueDetail(item)">
          <span style="margin-left: 10px;font-size: 16px;">{{item.name}}</span>
          <div class="right">
            <span>离线{{item.deviceList.filter(d=>d.isOnline === 0).length + '/' + item.deviceList.length}}</span>
            <img :src="require('../../../resource/img/device/svg/cz.svg')"
                 style="width: 20px;height: 20px;margin-left:10px;">
          </div>
        </div>
        <div v-for="(sub, subIndex) in item.deviceList" :key="subIndex" class="sub-item"
             @click="deviceDetail(item, sub)">
          <span style="margin-left: 10px;font-size: 14px;">{{sub.name + sub.deviceId}}</span>
          <div class="right" style="color: #d81e06;" @click.stop="refreshDevice(sub)">
            <span
              :style="{color: sub.isOnline === 1 ? '#04bf02' : '#d81e06'}">{{sub.isOnline === 1 ? '在线' : '离线'}}</span>
            <img v-if="sub.isOnline === 1" :src="require('../../../resource/img/device/svg/signal.svg')"
                 style="width: 20px;height: 20px;">
            <nut-icon type="right" color="#D4D4D4" style="margin-left: 10px;"/>
          </div>
        </div>
      </div>
      <no-data :data="list"/>
      <div style="height: 68px;"></div>
      <nut-backtop :bottom="78"/>
      <!--场地详情弹窗-->
      <nut-popup v-model="showVenueDetail" :closeable="true" position="bottom">
        <div
          style="display: flex;justify-content: center; align-items: center; height: 45px; border-bottom: 0.5px solid #D4D4D4;font-size:16px;">
          场地详情
        </div>
        <div
          style="display: flex;align-items: center;justify-content: space-between;padding: 20px 0;background-color: #f5f6f7;">
          <div style="margin-left: 10px;">
            <div style="font-size: 16px;margin-bottom: 5px;">{{currItem.name}}</div>
            <div style="color: #8c8c8c;">共{{currItem.deviceList ? currItem.deviceList.length :
              0}}台,离线{{currItem.deviceList ? currItem.deviceList.filter(d=>d.isOnline === 0).length : 0}}台
            </div>
          </div>
          <span @click="addressEdit" style="color: #1a87ff;margin-right: 10px;font-size: 14px;">编辑地址</span>
        </div>
        <div style="display: flex;border-top: 0.5px solid #D4D4D4;">
          <div @click="$router.push('/device/SiteEarnings')"
               style="height:100px;width:33%; display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <img :src="require('../../../resource/img/device/svg/earnings.svg')" style="width: 30px;height: 30px;">
            <span>场地收益</span>
          </div>
        </div>
      </nut-popup>
      <!--场地详情 end-->
      <!--设备详情 -->
      <nut-popup v-model="showDeviceDetail" :closeable="true" position="bottom">
        <div
          style="display: flex;justify-content: center; align-items: center; height: 45px; border-bottom: 0.5px solid #D4D4D4;font-size:16px;">
          设备详情
        </div>
        <div
          style="display: flex;align-items: center;justify-content: space-between;padding: 20px 0;background-color: #f5f6f7;">
          <div style="margin-left: 10px;">
            <div style="font-size: 16px;margin-bottom: 5px;display: flex;align-items: center;">
              <span>{{currSubItem.name + currSubItem.deviceId}}</span>
              <div v-if="currSubItem.isOnline === 1"
                   style="margin-left: 10px; padding: 1px 3px; font-size: 12px; border-radius: 2px;background-color: #04BE01;color:white;">
                在线
              </div>
              <div v-if="currSubItem.isOnline === 0"
                   style="margin-left: 10px; padding: 1px 3px; font-size: 12px; border-radius: 2px;background-color: #ff524c;color:white;">
                离线
              </div>
            </div>
            <div style="color: #8c8c8c;">{{'地址: ' + currItem.address}}{{'【' + currItem.name + '】'}}</div>
          </div>
        </div>
        <div style="display: flex;border-top: 0.5px solid #D4D4D4;">
          <div @click="createQrcode()"
               style="height:100px;width:33%; display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <img :src="require('../../../resource/img/device/svg/qrcode.svg')"
                 style="width: 30px;height: 30px;border-radius: 10px;background-color: #e9e9e9;padding: 10px;margin-bottom: 5px;">
            <span>生成二维码</span>
          </div>
          <div @click="showDeviceRemark = true"
               style="height:100px;width:33%; display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <img :src="require('../../../resource/img/device/svg/device_edit.svg')"
                 style="width: 30px;height: 30px;border-radius: 10px;background-color: #e9e9e9;padding: 10px;margin-bottom: 5px;">
            <span>备注和标签</span>
          </div>
        </div>
        <!--<nut-cell @click-cell="currSubItem.isOnline === 0 ? $toast.text('设备处于离线状态无法设置,请确保设备在线') : void 0" title="参数设置"
                  desc="接口板" :to="currSubItem.isOnline === 1 ? '/device/DeviceParameter' : null" :show-icon="true"
                  style="margin-bottom: 30px;"/>-->
      </nut-popup>
      <!--设备详情弹窗 end-->
      <!--设备二维码弹窗-->
      <nut-popup v-model="showDeviceQrcode" position="bottom" id="popup">
        <div style="background-color: #ffffff;width: 100%;">
          <div
            style="display: flex;justify-content: center; align-items: center; height: 45px; border-bottom: 0.5px solid #D4D4D4;font-size:16px;margin-bottom: 20px;">
            {{currSubItem.name + currSubItem.deviceId}}
          </div>
          <div id="box" ref="box" v-if="imgData == ''"
               style="display: flex;flex-direction:column;justify-content: center; align-items: center;margin-bottom: 10px;">
            <span style="margin-bottom: 10px;">设备码:{{currSubItem.deviceId}}</span>
            <div id="codeDiv"></div>
          </div>
          <div style="display: flex;flex-direction:column;justify-content: center; align-items: center;">
            <img style="width: 410px;margin-bottom: 10px;" :src="imgData" alt/>
            <div style="margin-bottom: 10px;text-align: center">长按二维码，保存或发送给朋友</div>
          </div>
        </div>
      </nut-popup>
      <!--设备二维码弹窗 end-->
      <!--设备备注和标签-->
      <nut-popup v-model="showDeviceRemark" position="bottom">
        <div style="background-color: #f3f4f5;width: 100%;">
          <div
            style="background-color: #ffffff; display: flex;justify-content: center; align-items: center; height: 45px; border-bottom: 0.5px solid #D4D4D4;font-size:16px;margin-bottom: 20px;">
            {{currSubItem.name + currSubItem.deviceId}}
          </div>
          <nut-textbox v-model="remarkForm.remark" :txt-area-h="100" place-text="请在此输入备注" :max-num="150"></nut-textbox>
          <nut-cell title="标签" desc="设置" :show-icon="true" style="margin: 30px 0;"/>
          <nut-buttongroup>
            <nut-button type="light" @click="showDeviceRemark = false">取消</nut-button>
            <nut-button @click="saveRemark" style="background: #1a87ff;">确定</nut-button>
          </nut-buttongroup>
        </div>
      </nut-popup>
      <!--设备备注和标签 end-->
    </div>
    <!--设备分析-->
    <div style="margin-top:10px;" v-if="tab === 1">
      <nut-cell :is-link="true" to="/device/AbnormalDevice" :show-icon="true">
        <span slot="title">设备状态</span>
        <span slot="sub-title">设备最新活跃时间</span>
        <span slot="desc">共{{analysis.countNum || 0}}台</span>
      </nut-cell>
      <nut-cell :is-link="true" to="/device/StartDistribution" :show-icon="true">
        <span slot="title">当日启动率{{analysis.startupRate||0.00}}%</span>
        <span slot="desc">共{{analysis.countNum || 0}}台,启动{{analysis.onlineCount || 0}}台</span>
      </nut-cell>
    </div>
    <!--设备故障-->
    <div v-if="tab === 2">
      <nut-tab :line-width="60">
        <nut-tab-panel tab-title="待处理">
          <div style="background-color:#fff;padding: 5px 0;">
            <nut-searchbar placeText="请输入场地名称或者设备编号" style="margin: 0 10px;zoom: 0.9;"/>
          </div>
          <no-data :data="[]"/>
        </nut-tab-panel>
        <nut-tab-panel tab-title="已处理">
          <div style="background-color:#fff;padding: 5px 0;">
            <nut-searchbar placeText="请输入场地名称或者设备编号" style="margin: 0 10px; zoom: 0.9;"/>
          </div>
          <no-data :data="[]"/>
        </nut-tab-panel>
      </nut-tab>
    </div>
    <nut-tabbar @tab-switch="tabSwitch" :tabbar-list="tabList" :bottom="true"/>
  </div>
</template>

<script>

import QRCode from 'qrcodejs2'
import {qrcanvas} from 'qrcanvas'  // 引入qrcode
import html2canvas from 'html2canvas'

/**
 * 设备管理
 */
export default {
  name: 'DeviceManagement',
  data () {
    return {
      tab: 0,
      imgData: '',
      query: {
        //设备状态筛选
        deviceStatus: -1,
        //场地地址id
        addressId: 0,
        //设备类型
        deviceType: 0,
        //关键字搜索
        searchName: ''
      },
      tabList: [
        {
          'tabTitle': '设备管理',
          'curr': true,
          'icon': require('../../../resource/img/device/hardware.png'),
          'activeIcon': require('../../../resource/img/device/hardware_active.png')
        },
        {
          'tabTitle': '设备分析',
          'curr': false,
          'icon': require('../../../resource/img/device/data.png'),
          'activeIcon': require('../../../resource/img/device/data_active.png')
        },
        {
          'tabTitle': '设备故障',
          'curr': false,
          'icon': require('../../../resource/img/device/warning.png'),
          'activeIcon': require('../../../resource/img/device/warning_active.png')
        }
      ],
      isVisible1: false,
      isVisible2: false,
      isVisible3: false,
      page: 1,
      limit: 10,
      addressList: [
        {
          id: 0,
          name: '全部场地',
          selected: true
        }
      ],
      deviceTypeList: [
        {
          id: 0,
          name: '全部类型',
          selected: true
        }
      ],
      list3: [
        {
          id: 0,
          text: '分组标签',
          selected: true
        }
      ],
      //离线说明
      helpShow: false,
      //场地详情弹窗是否显示
      showVenueDetail: false,
      //设备详情弹窗是否显示
      showDeviceDetail: false,
      //设备备注和标签弹窗是否显示
      showDeviceRemark: false,
      //设备二维码弹窗显示
      showDeviceQrcode: false,
      //设备备注和标签form
      remarkForm: {
        remark: ''
      },
      list: [],
      //当前选择的场地
      currItem: {},
      //当前选择设备
      currSubItem: {},
      //设备分析数据
      analysis: {}
    }
  },
  mounted () {
    this.getData()
    this.findAddress()
    this.findDeviceType()
  },
  methods: {
    search (value) {
      this.query.searchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.search.blur()
      this.getData()
    },
    //显示场地详情
    venueDetail (item) {
      this.showVenueDetail = true
      this.currItem = item
    },
    //显示设备详情
    deviceDetail (item, subItem) {
      this.showDeviceDetail = true
      this.currItem = item
      this.currSubItem = subItem
      this.remarkForm.remark = subItem.remark
    },
    //生成设备二维码
    createQrcode () {
      this.imgData = ''
      this.showDeviceQrcode = true
      this.qrcode()
    },
    qrcode () {
      this.$nextTick(() => {
        const opts = {
          allowTaint: false,
          logging: false,
          useCORS: true,
          scrollY: 0
        }
        new QRCode('codeDiv', {
          text: 'http://' + window.location.host + '/device/DeviceUse?deviceId=' + this.currSubItem.deviceId,
          render: 'canvas',  //渲染方式指定canvas方式
          width: 200,
          height: 200,
          typeNumber: -1,//计算模式
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
        html2canvas(this.$refs.box, opts).then(canvas => {
          //将canvas转为base64图片(eg. data:image/png;base64,ijskjlkj)
          this.imgData = canvas.toDataURL()
        })
      })
    },
    // qrcode () {
    //   this.$nextTick(() => {
    //     const opts = {
    //       useCORS: true
    //     }
    //     let codeDiv = qrcanvas({
    //       data: 'http://' + window.location.host + '/device/DeviceUse?deviceId=' + this.currSubItem.deviceId, //分享链接（根据需求来）
    //       size: 218 //二维码大小
    //     })
    //     document.getElementById('codeDiv').innerHTML = ''
    //     document.getElementById('codeDiv').appendChild(codeDiv)
    //     html2canvas(this.$refs.box, opts).then(canvas => {
    //       //将canvas转为base64图片(eg. data:image/png;base64,ijskjlkj)
    //       this.imgData = canvas.toDataURL()
    //     })
    //   })
    // },
    //保存设备备注
    saveRemark () {
      this.$api.post({
        url: '/device/api/device/remark',
        data: {
          id: this.currSubItem.id,
          remark: this.remarkForm.remark
        }
      }).then(res => {
        this.showDeviceRemark = false
        this.currSubItem.remark = this.remarkForm.remark
        this.getData()
      })
    },
    /**编辑投放地址*/
    addressEdit () {
      let item = this.$util.clone(this.currItem)
      item.deviceList = []
      this.$router.push({
        path: '/device/AddressAdd',
        query: {
          data: encodeURIComponent(JSON.stringify(item))
        }
      })
    },
    //查询设备类型列表
    findDeviceType () {
      this.$api.post({
        url: '/device/api/device/device-type/find/list',
        loading: false
      }).then(res => {
        this.deviceTypeList = this.deviceTypeList.concat(res.data)
      })
    },
    //查询场地列表
    findAddress () {
      this.$api.post({
        url: '/device/api/device/address/find',
        loading: false
      }).then(res => {
        this.addressList = this.addressList.concat(res.data)
      })
    },
    switchMenu (num) {
      Array.from(document.querySelectorAll('.list')).forEach(item => {
        item.style.zIndex = 0
      })
      if (!this['isVisible' + num]) {
        document.querySelector('.list' + num).style.zIndex = 9999
      }
      this['isVisible' + num] = !this['isVisible' + num]
    },
    chooseMenu (item, index, list, num) {
      this.switchMenu(num)
      list.map((value, key) => value.selected = false)
      this.$set(list[index], 'selected', true)
      this.$refs[`title${num}`].innerText = item.name
      if (num === 1) {
        this.query.addressId = item.id
      }
      if (num === 2) {
        this.query.deviceType = item.id
      }
      this.getData()
    },
    goStatus (num) {
      this.query.deviceStatus = num
      this.getData()
    },
    /**
     * 底部导航栏切换事件
     * @param index
     * @param event
     */
    tabSwitch: function (event, index) {
      this.tab = index
      if (index === 1) {//设备分析
        this.getAnalysis()
      }
    },
    //获取设备分析数据
    getAnalysis () {
      this.$api.post({
        url: '/device/api/device/analysis',
        data: {
          merId: this.$api.merId
        }
      }).then(res => {
        this.analysis = res.data
      })
    },
    getData () {
      let data = {}
      if (this.query.deviceStatus > -1) {
        data.isOnline = this.query.deviceStatus
      }
      if (this.query.addressId != 0) {
        data.addressId = this.query.addressId
      }
      if (this.query.deviceType != 0) {
        data.deviceType = this.query.deviceType
      }
      if (this.query.searchName != '') {
        data.searchName = this.query.searchName
      }
      this.$api.post({
        url: '/device/api/device/address/device-list',
        data: data
      }).then(res => {
        this.list = res.data
      })
    },
    //刷新设备在线情况
    refreshDevice (item) {
      this.$api.post({
        url: '/device/api/device/refresh',
        data: {
          deviceId: item.deviceId
        }
      }).then(res => {
        item.isOnline = res.data.isOnline
      })
    }
  }
}
</script>

<style scoped>
  >>> .nut-tab {
    user-select: none;
    padding: 0;
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  >>> .nav-bar {
    background-color: #194fff;
  }

  >>> .nut-tab-active a {
    color: #194fff;
  }

  >>> .nut-tab-item {
    padding: 0;
    background-color: #F5F6F8;
    border: none;
  }

  >>> .curr {
    color: #1a87ff;
  }

  >>> .nut-dialog-btn:only-child {
    color: #1a87ff;
  }

  >>> .nut-dialog-ok:active {
    background: #1a87ff;
    color: white;
  }

  .flex-content {
    user-select: none;
    color: #8f8f94;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 5px 0;
    border: 1px solid #8f8f94;
  }

  .list {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    justify-content: center;
    min-height: 35px;
    width: 99%;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
    outline: none;
    background-color: #fff;
    background-image: -webkit-gradient(linear, left top, left bottom, from(hsla(0, 0%, 85.5%, .5)), to(hsla(0, 0%, 85.5%, .5)));
    background-image: -o-linear-gradient(hsla(0, 0%, 85.5%, .5), hsla(0, 0%, 85.5%, .5));
    background-image: linear-gradient(hsla(0, 0%, 85.5%, .5), hsla(0, 0%, 85.5%, .5));
    background-size: 100% 1px;
    background-repeat: no-repeat;
  }

  .tips-div {
    color: #8a8a8a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 10px;
    min-height: 35px;
  }

  .list-item {
    margin-bottom: 10px;
    background-color: white;
  }

  .list-item .top-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: #D4D4D4 0.5px solid;
  }

  .list-item .top-item .right {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .list-item .sub-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 10px;
    padding: 12px 0;
    border-bottom: #D4D4D4 0.5px solid;
  }

  .list-item .sub-item .right {
    display: flex;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/device/home/DeviceManagement.vue